import React, { Component } from "react";
import { connect } from "react-redux";
import { ShowVisibleNextAtd, ShowInfoDisplay } from "../actions";
import MicroModal from "micromodal";
import Moment from "moment";

var keycount = 1;

const mapStateToProps = (state) => {
  return {
    DisplayNextAtd: state.displaynextatd,
    DisplayDetails: state.displaydetailsatd,
    UserGroups: state.groups,
    Messages: state.messages,
    InfoUsers: state.informationusers,
    RegisterNotifier: state.registernotifier,
    IPCurrent: state.ipcurrent,
    Notifications: state.notifications,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowVisibleNextAtdIn: (post, temp) => {
    dispatch(ShowVisibleNextAtd(post, temp));
  },
  ShowInfoDisplay: (post) => {
    dispatch(ShowInfoDisplay(post));
  },
});

class NotifierModal extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: "", textInput: "" };
  }

  ShowInfoDisplay(e, display) {
    if (display === "mensagemchat") {
      this.props.ShowInfoDisplay("Atendentes");
      MicroModal.close("modal__notificacoes");
    } else if (display === "mensagemgrupo") {
      MicroModal.show("modal__mensagem-equipe");
      MicroModal.close("modal__notificacoes");
    }
    document.getElementById("simulation_click").click();
    this.setState({ newnotifier: false });
  }

  render() {
    const { RegisterNotifier } = this.props;

    return (
      <div className="modal__overlay" tabIndex="-1">
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__notificacoes__title"
          >
            <header className="modal__header">
              <h2 className="modal__title" id="modal__notificacoes__title">
                Notificações
              </h2>
              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </header>
            <main className="modal__content" id="modal__notificacoes__content">
              <div className="anotc__wrapper">
                <div className="anotc__mp">
                  <div className="anotc__mp-ctrL">
                    <div className="anotc__mp-date">
                      <p className="anotc__mp-date-text">
                        Deseja buscar as notificações em qual período?
                      </p>
                      <div className="anotc__mp-date-wrapper">
                        <span className="anotc__mp-date-span">De:</span>
                        <input type="date" className="anotc__mp-date-start" />
                        <span className="anotc__mp-date-span">Até:</span>
                        <input type="date" className="anotc__mp-date-end" />
                      </div>
                    </div>
                    <div className="anotc__mp-critic">
                      <p className="anotc__mp-critic-text">Filtro por Status</p>
                      <div className="anotc__mp-critic-wrapper">
                        <button className="anotc__mp-critic-btn">
                          Todos
                          <i className="anotc__mp-critic-icon material-icons">
                            keyboard_arrow_down
                          </i>
                        </button>
                        <div className="anotc__mp-critic-options">
                          <ul className="anotc__mp-critic-list">
                            <li className="anotc__mp-critic-item">Todas</li>
                            <li className="anotc__mp-critic-item">Lidas</li>
                            <li className="anotc__mp-critic-item">Não lidas</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal__content__tabs__body__tab__result modal__content__tabs__body__tab__result--notification">
                    <div className="hist-atd__search">
                      <span className="material-icons hist-atd__search-icon">
                        expand_less
                      </span>
                      <span className="material-icons hist-atd__search-icon">
                        expand_more
                      </span>
                      <input
                        type="text"
                        className="hist-atd__search-input"
                        placeholder="Pesquisar..."
                      />
                      <button className="hist-atd__search-btn hist-atd__search-btn--two">
                        Concluir
                      </button>
                    </div>
                    {RegisterNotifier.map((notifier) =>
                      (() => {
                        var now = Moment();
                        var before = Moment(notifier.data);
                        var data = Moment(now - before).format("m[min]");
                        return (
                          <div
                            className="item-notification item-notification--chat"
                            key={keycount++}
                          >
                            <div className="item-notification__content">
                              <i className="material-icons">announcement</i>
                              <p
                                className="item-notification__content__title"
                                onClick={(event) =>
                                  this.ShowInfoDisplay(
                                    event,
                                    notifier.display,
                                    notifier.idnotifier
                                  )
                                }
                              >
                                <span className="item-notification__content__title item-notification__content__title__name">
                                  {notifier.author} :
                                </span>
                                {notifier.display === "mensagemingdesk"
                                  ? notifier.mensagem
                                  : notifier.description}

                                <span className="item-notification__content__title item-notification__content__title__time">
                                  ({data})
                                </span>
                              </p>
                            </div>
                          </div>
                        );
                      })()
                    )}
                    {/* <!-- end item --> */}
                  </div>
                </div>
              </div>
            </main>

            <button className="hist-atd__fab btn--search-anotc">
              <i className="material-icons">search</i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotifierModal);
